/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Model_Update_SuccessInputs */



/**
* | output |
* | --- |
* | "Default model updated successfully" |
*
* @param {Preferences_Model_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_model_update_success = /** @type {((inputs?: Preferences_Model_Update_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Model_Update_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmodell erfolgreich aktualisiert")
	return /** @type {LocalizedString} */ ("Default model updated successfully")
});